import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import PropTypes from 'prop-types';
import * as styles from './DataSizeChart.css';

const cx = classNames.bind(styles);

/* istanbul ignore next */
export class DataSizeChart extends Component {
    initialized = false;

    updateTruFitViewTimeOut = null;

    static defaultProps = {
        showKALink: () => '',
        productDetails: {},
        selectedSKUId: '',
        optionsSelected: [],
        disableDataSizeChart: false,
    };

    static propTypes = {
        showKALink: PropTypes.func,
        productDetails: PropTypes.object,
        optionsSelected: PropTypes.array,
        disableDataSizeChart: PropTypes.bool,
        selectedSKUId: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.state = {
            checkMeaurements: false,
            filterSize: [],
        };
    }

    componentDidMount() {
        if (!this.initialized) {
            this.updateTruFitView();
        }
        this.initializeSizeChartData();
    }

    componentDidUpdate(prevProps) {
        if (!this.initialized) {
            this.updateTruFitView();
        }
        if (
            prevProps.productDetails !== this.props.productDetails ||
            prevProps.optionsSelected !== this.props.optionsSelected ||
            prevProps.selectedSKUId !== this.props.selectedSKUId
        ) {
            this.initialized = false;
            this.initializeSizeChartData();
            this.updateTruFitView();
        }
    }

    componentWillUnmount() {
        this.initialized = false;
        clearTimeout(this.updateTruFitViewTimeOut);
    }

    updateTruFitView() {
        const { checkMeaurements } = this.state;
        if (!this.initialized) {
            clearTimeout(this.updateTruFitViewTimeOut);
            this.updateTruFitViewTimeOut = setTimeout(() => {
                const getFitProductElm = document.querySelectorAll(
                    '#size-details .tfc-fitrec-product'
                );
                if (getFitProductElm && getFitProductElm[0] && getFitProductElm[0].style) {
                    getFitProductElm[0].style.margin = checkMeaurements ? '20px 0px' : '0px';
                    const productElmHasHeight = getFitProductElm[0].style.minHeight !== 'initial';
                    const truFitDataElm = document.querySelectorAll('.tfc-fitrec-result');
                    if (productElmHasHeight) {
                        if (truFitDataElm && truFitDataElm[0]) {
                            truFitDataElm[0].style.margin = checkMeaurements ? '20px 0px' : '0px';
                            this.initialized = true;
                        } else {
                            this.updateTruFitView();
                        }
                    } else {
                        getFitProductElm[0].style.display = 'none';
                        this.initialized = true;
                    }
                } else {
                    this.updateTruFitView();
                }
            }, 100);
        }
    }

    initializeSizeChartData() {
        const { productDetails, optionsSelected, disableDataSizeChart, selectedSKUId } = this.props;
        const { lots = [] } = productDetails;
        let filterSelectedSku = [];
        let filterSelectedlot = [];
        let filterSize = [];
        let userSizeRangeSelected = '';
        let userSizeSelected = '';
        let checkMeaurements = false;

        if (optionsSelected?.length && !disableDataSizeChart) {
            optionsSelected.filter((optionSelectedItems) => {
                if (optionSelectedItems.type === 'SIZE_RANGE') {
                    userSizeRangeSelected = optionSelectedItems.name.toLowerCase();
                } else if (optionSelectedItems.type === 'SIZE') {
                    userSizeSelected = optionSelectedItems.name.toLowerCase();
                }
            });
            const checkFilterSizeandSizeRange =
                lots?.length && userSizeRangeSelected && userSizeSelected;
            const checkFilterSize = lots?.length && userSizeSelected;
            let sizeMeasurements = [];
            if (checkFilterSizeandSizeRange) {
                filterSelectedlot = lots?.find((lot) => {
                    return lot.items.some((item) => {
                        return item.id === selectedSKUId;
                    });
                });
                filterSelectedSku = filterSelectedlot?.items.filter(
                    (item) => item.id === selectedSKUId
                );

                if (filterSelectedSku?.length) {
                    sizeMeasurements =
                        filterSelectedSku &&
                        filterSelectedSku[0] &&
                        filterSelectedSku[0].measurements;
                }
            } else if (checkFilterSize) {
                filterSelectedlot =
                    selectedSKUId &&
                    lots?.find((lot) => {
                        return lot.items?.some((item) => {
                            return item.id === selectedSKUId;
                        });
                    });
                filterSelectedSku = filterSelectedlot?.items?.filter(
                    (item) => item.id === selectedSKUId
                );

                if (filterSelectedSku?.length) {
                    sizeMeasurements =
                        filterSelectedSku &&
                        filterSelectedSku[0] &&
                        filterSelectedSku[0].measurements;
                }
            }

            if (sizeMeasurements) {
                filterSize = sizeMeasurements;
                checkMeaurements = sizeMeasurements?.length > 0;
            }
        }
        this.setState({ checkMeaurements, filterSize });
    }

    render() {
        const { checkMeaurements, filterSize } = this.state;
        return (
            <section id="size-details" className={cx('detail-size-container')}>
                {checkMeaurements && (
                    <section
                        className={`${dt(['flex', 'flex-wrap', 'pt-4', 'text-sm'])} ${cx(
                            'detail-table'
                        )}`}
                    >
                        <>
                            <header
                                className={dt([
                                    'text-gray-70',
                                    'font-open-sans',
                                    'font-semibold',
                                    'lg:w-[40%]',
                                    'mdOnly:w-[33%]',
                                    'smOnly:w-[20%]',
                                ])}
                            >
                                <div
                                    className={dt([
                                        'whitespace-nowrap',
                                        'overflow-hidden',
                                        'overflow-ellipsis',
                                        'text-small',
                                    ])}
                                >
                                    {filterSize[0]?.name}
                                </div>
                                {filterSize?.slice(1).map((item) => (
                                    <div
                                        className={dt([
                                            'whitespace-nowrap',
                                            'overflow-hidden',
                                            'overflow-ellipsis',
                                            'text-small',
                                        ])}
                                    >
                                        {item.name}
                                    </div>
                                ))}
                            </header>
                            <div
                                className={`${dt([
                                    'row',
                                    'text-gray-70',
                                    'text-small',
                                    'lg:!mx-0',
                                ])} ${cx('detailsWidth')}`}
                            >
                                <div className={dt(['flex'])}>{filterSize[0].value}</div>
                                {filterSize?.slice(1).map((item) => (
                                    <div>{item.value}</div>
                                ))}
                            </div>
                        </>
                    </section>
                )}
            </section>
        );
    }
}
export default DataSizeChart;
